import { AAKeyword } from '../../lib/types/models/aa-keywords/aa-keyword'
import { AAKeywordInput } from '../../lib/types/models/aa-keywords/aa-keyword-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createAAKeyword(data: AAKeywordInput) {
  return restApiClient.url(constructApiUrl(API.aAKeyWords.create.url, null)).post<AAKeyword>(data)
}
